export const SERVICE_TYPE = 'service';
